var _circle, _circle2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudentProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5996,
    cy: 24.6001,
    r: 24.3,
    fill: "#F7F8F9",
    stroke: "#E3E3E3",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3285_32956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 49
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5996,
    cy: 24.6001,
    r: 24,
    fill: "#212121"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3285_32956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5996 10.2925C22.3063 10.2925 20.3484 11.1038 18.7258 12.7264C17.1032 14.349 16.2919 16.3069 16.2919 18.6002C16.2919 20.8934 17.1032 22.8514 18.7258 24.474C20.3484 26.0966 22.3063 26.9079 24.5996 26.9079C26.8929 26.9079 28.8508 26.0966 30.4734 24.474C32.096 22.8514 32.9073 20.8934 32.9073 18.6002C32.9073 16.3069 32.096 14.349 30.4734 12.7264C28.8508 11.1038 26.8929 10.2925 24.5996 10.2925ZM24.5996 29.6771C26.215 29.6771 27.852 29.8357 29.5107 30.1531C31.1693 30.4704 32.7847 30.9716 34.3568 31.6567C35.9289 32.3418 37.3244 33.1639 38.5431 34.123C39.7619 35.0821 40.7426 36.254 41.4854 37.6386C42.2282 39.0233 42.5996 40.5233 42.5996 42.1386C42.5996 43.2204 42.1886 44.1831 41.3664 45.0269C40.5443 45.8706 39.5708 46.2925 38.4458 46.2925L24.5996 53.6258L10.7535 46.2925C9.62846 46.2925 8.6549 45.8706 7.83278 45.0269C7.01067 44.1831 6.59961 43.2204 6.59961 42.1386C6.59961 40.5233 6.971 39.0233 7.71379 37.6386C8.45658 36.254 9.43735 35.0821 10.6561 34.123C11.8749 33.1639 13.2703 32.3418 14.8424 31.6567C16.4145 30.9716 18.0299 30.4704 19.6886 30.1531C21.3472 29.8357 22.9842 29.6771 24.5996 29.6771Z",
    fill: "#D6DCE2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentProfile);
export default __webpack_public_path__ + "static/media/student_profile.0c491f16.svg";
export { ForwardRef as ReactComponent };